import { createApiSlice } from "@common/common-slice/commonSlice";

// routes
import {
  CRUD_SKILL_AREA,
  TALENAISE_GENERATE,
  GET_SKILL_AREA,
  GET_SKILL_AREA_DETAILS,
  STORE_SKILL_AREA,
} from "@routes";

const apiConfig = [
  {
    name: "createSkillArea",
    method: "post",
    url: CRUD_SKILL_AREA,
    stateKey: "message",
  },
  {
    name: "getSkillArea",
    method: "get",
    url: GET_SKILL_AREA,
    stateKey: "data",
  },
  {
    name: "getSkillAreaDetails",
    method: "get",
    url: GET_SKILL_AREA_DETAILS,
    stateKey: "detailsData",
  },
  {
    name: "generateArea",
    method: "post",
    url: TALENAISE_GENERATE,
    stateKey: "generatedData",
    loadingKey: "genLoading",
  },
  {
    name: "storeGeneratedArea",
    method: "post",
    url: STORE_SKILL_AREA,
    stateKey: "message",
    loadingKey: "genLoading",
  },
  {
    name: "updateSkillArea",
    method: "put",
    url: CRUD_SKILL_AREA,
    stateKey: "message",
  },
  {
    name: "deleteSkillArea",
    method: "delete",
    url: CRUD_SKILL_AREA,
    stateKey: "message",
  },
];

// ---------------------------------------------------------------------

const customReducers = {
  initialState: {
    detailsData: [],
    generatedData: [],
    selectedAreaData: {},
    generate: false,
    genLoading: false,
  },

  reducers: {
    skillAreaSelect: (state, action) => {
      state.selectedAreaData = action?.payload;
    },
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "skillArea",
  apiConfig,
  customReducers,
);

const skillAreaSlice = slice;

export default skillAreaSlice.reducer;

export const {
  createSkillArea,
  getSkillArea,
  getSkillAreaDetails,
  generateArea,
  storeGeneratedArea,
  updateSkillArea,
  deleteSkillArea,
} = thunks;

export const {
  rowSelect,
  skillAreaSelect,
} = actions;